interface StatsCardProps {
  value: number;
  label: string;
  color?: 'purple' | 'green' | 'coral';
}

export default function StatsCard({ value, label, color = 'purple' }: StatsCardProps) {
  const colorClasses = {
    purple: 'text-purple-600',
    green: 'text-green-500',
    coral: 'text-brand-500',
  };

  return (
    <div className="rounded-2xl border border-gray-200 bg-white p-6 dark:border-gray-800 dark:bg-white/[0.03]">
      <div className="flex flex-col items-center justify-center">
        <span className={`text-5xl font-bold ${colorClasses[color]} sm:text-6xl`}>
          {value.toLocaleString()}
        </span>
        <span className="mt-2 text-sm text-gray-500 dark:text-gray-400">
          {label}
        </span>
      </div>
    </div>
  );
}
